import { StyleSheet, View } from "react-native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { ChatStackParamList } from "../../types/navigationParams";

type Props = NativeStackScreenProps<ChatStackParamList, "VideoScreen">;

const VideoScreen = (props: Props) => {
  const { videoSource } = props.route.params;

  return (
    <View style={styles.container}>
      <View style={styles.videoContainer}>
        <video controls src={videoSource} style={styles.video} />
      </View>
    </View>
  );
};

export default VideoScreen;

const styles = StyleSheet.create({
  container: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  videoContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "100%",
    maxHeight: "80%",
  },
  video: {
    width: "100%",
    height: "100%",

    borderRadius: 12,
    backgroundColor: "black",
  },
});
